/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Subscribetotopic2Inputs */

const id_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan ke Topik`)
};

const ms_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langgan Topik`)
};

const da_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner på Emne`)
};

const de_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema abonnieren`)
};

const en_us2_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Topic`)
};

const es_es2_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse a un tema`)
};

const es_mx2_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse a un tema`)
};

const fil_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-subscribe sa Paksa`)
};

const fr_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'abonner à un sujet`)
};

const it_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti all'argomento`)
};

const hu_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozás témára`)
};

const nl_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneren op onderwerp`)
};

const no_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonner på emne`)
};

const pl_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybuj temat`)
};

const pt_br2_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Topic`)
};

const pt_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrever tópico`)
};

const ro_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonează-te la subiect`)
};

const fi_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaa aihe`)
};

const sv_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumerera på ämne`)
};

const vi_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký chủ đề`)
};

const tr_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konuya Abone Ol`)
};

const cs_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se k tématu`)
};

const bg_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абониране за тема`)
};

const ru_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться на тему`)
};

const uk_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписатися на тему`)
};

const ar_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراك في موضوع`)
};

const hi_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विषय की सदस्यता लें`)
};

const th_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับหัวข้อ`)
};

const ja_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トピックを購読`)
};

const zh_cn2_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Topic`)
};

const zh_hant1_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to Topic`)
};

const ko_notifications_push_subscribetotopic2 = /** @type {(inputs: Notifications_Push_Subscribetotopic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주제 구독`)
};

/**
* | output |
* | --- |
* | "Subscribe to Topic" |
*
* @param {Notifications_Push_Subscribetotopic2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_subscribetotopic2 = /** @type {((inputs?: Notifications_Push_Subscribetotopic2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Subscribetotopic2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_subscribetotopic2(inputs)
	if (locale === "ms") return ms_notifications_push_subscribetotopic2(inputs)
	if (locale === "da") return da_notifications_push_subscribetotopic2(inputs)
	if (locale === "de") return de_notifications_push_subscribetotopic2(inputs)
	if (locale === "en-US") return en_us2_notifications_push_subscribetotopic2(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_subscribetotopic2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_subscribetotopic2(inputs)
	if (locale === "fil") return fil_notifications_push_subscribetotopic2(inputs)
	if (locale === "fr") return fr_notifications_push_subscribetotopic2(inputs)
	if (locale === "it") return it_notifications_push_subscribetotopic2(inputs)
	if (locale === "hu") return hu_notifications_push_subscribetotopic2(inputs)
	if (locale === "nl") return nl_notifications_push_subscribetotopic2(inputs)
	if (locale === "no") return no_notifications_push_subscribetotopic2(inputs)
	if (locale === "pl") return pl_notifications_push_subscribetotopic2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_subscribetotopic2(inputs)
	if (locale === "pt") return pt_notifications_push_subscribetotopic2(inputs)
	if (locale === "ro") return ro_notifications_push_subscribetotopic2(inputs)
	if (locale === "fi") return fi_notifications_push_subscribetotopic2(inputs)
	if (locale === "sv") return sv_notifications_push_subscribetotopic2(inputs)
	if (locale === "vi") return vi_notifications_push_subscribetotopic2(inputs)
	if (locale === "tr") return tr_notifications_push_subscribetotopic2(inputs)
	if (locale === "cs") return cs_notifications_push_subscribetotopic2(inputs)
	if (locale === "bg") return bg_notifications_push_subscribetotopic2(inputs)
	if (locale === "ru") return ru_notifications_push_subscribetotopic2(inputs)
	if (locale === "uk") return uk_notifications_push_subscribetotopic2(inputs)
	if (locale === "ar") return ar_notifications_push_subscribetotopic2(inputs)
	if (locale === "hi") return hi_notifications_push_subscribetotopic2(inputs)
	if (locale === "th") return th_notifications_push_subscribetotopic2(inputs)
	if (locale === "ja") return ja_notifications_push_subscribetotopic2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_subscribetotopic2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_subscribetotopic2(inputs)
	return ko_notifications_push_subscribetotopic2(inputs)
});
export { notifications_push_subscribetotopic2 as "notifications.push.subscribeToTopic" }